import { Injectable, OnDestroy } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class MatPaginationIntlService extends MatPaginatorIntl {
	private resizeListener: () => void;

	constructor(private translate: TranslateService) {
		super();
		this.translate.onLangChange.subscribe((_event: Event) => {
			this.translateLabels();
		});
		this.translateLabels();

		this.resizeListener = this.addResizeListener();
	}

	private isMobile(): boolean {
		return window.innerWidth <= 959; // Breakpoint for mobile
	}

	private addResizeListener(): () => void {
		const listener = () => this.translateLabels();
		window.addEventListener("resize", listener);
		return () => window.removeEventListener("resize", listener);
	}

	public injectTranslateService(translate: TranslateService): void {
		this.translate = translate;
		this.translate.onLangChange.subscribe(() => {
			this.translateLabels();
		});
		this.translateLabels();
	}

	private translateLabels(): void {
		this.itemsPerPageLabel = this.translate.instant(
			"I18N.MAT_PAGINATOR.ITEMS_PER_PAGE"
		);
		this.nextPageLabel = this.translate.instant(
			"I18N.MAT_PAGINATOR.NEXT_PAGE"
		);
		this.previousPageLabel = this.translate.instant(
			"I18N.MAT_PAGINATOR.PREVIOUS_PAGE"
		);
		this.firstPageLabel = this.translate.instant(
			"I18N.MAT_PAGINATOR.FIRST_PAGE"
		);
		this.lastPageLabel = this.translate.instant(
			"I18N.MAT_PAGINATOR.LAST_PAGE"
		);

		if (this.isMobile()) {
			this.itemsPerPageLabel = "";
		}

		this.changes.next();
	}

	getRangeLabel = (
		page: number,
		pageSize: number,
		length: number
	): string => {
		let result: string = "";

		let isPhone = this.isMobile();
		const of = this.translate
			? this.translate.instant("I18N.MAT_PAGINATOR.OF")
			: " of ";
		const trailing = this.translate
			? this.translate.instant("I18N.MAT_PAGINATOR.TRAILING")
			: "";
		if (length === 0 || pageSize === 0) {
			result = "0" + of + length + trailing;

			if (isPhone) {
				result = `${this.translate.instant(
					"I18N.MAT_PAGINATOR.ITEMS_PER_PAGE_MOBILE"
				)} 0/0`;
			}
		} else {
			length = Math.max(length, 0);
			const startIndex =
				page * pageSize > length
					? (Math.ceil(length / pageSize) - 1) * pageSize
					: page * pageSize;
			const endIndex = Math.min(startIndex + pageSize, length);
			result = startIndex + 1 + " - " + endIndex + of + length + trailing;

			if (isPhone) {
				result = `${this.translate.instant(
					"I18N.MAT_PAGINATOR.ITEMS_PER_PAGE_MOBILE"
				)} ${page + 1}/${Math.ceil(length / pageSize)}`;
			}
		}

		return result;
	};

	ngOnDestroy(): void {
		this.resizeListener(); // Clean up listener
	}
}
